export default __webpack_public_path__ + "static/media/timemgt_whitecard.2b68b961.svg";